
$(document).ready(function($) {

        var offset = '100%';

        $('.divide-content').each(function(index, el) {

            // var imgHeight = $(this).find('.featured-cta__image img').height();
            // var imgWidth = $(this).find('.featured-cta__image img').width();

            var waypoint = new Waypoint({
                element: el,
                handler: function(direction) {
                    if (direction === 'down') {

                        $(this.element).addClass('animated animatedFadeInUp fadeInUp ease-transition');
                    }
                    if (direction === 'up') {

                        $(this.element).removeClass('animated animatedFadeInUp fadeInUp');
                    }
                },
                offset: offset
            })
        });
        

		$('.divide-image').each(function(index, el) {

			// var imgHeight = $(this).find('.featured-cta__image img').height();
			// var imgWidth = $(this).find('.featured-cta__image img').width();

			var waypoint = new Waypoint({
			  	element: el,
			  	handler: function(direction) {
			    	if (direction === 'down') {

				    	$(this.element).addClass('anim-img-reveal');
					}
                    if (direction === 'up') {

                        $(this.element).removeClass('anim-img-reveal');
                    }
			  	},
			  	offset: offset
			})


		});
});